import { orderTypes } from "../types";

// Debounce map for quantity changes: key `${refId}_${itemId}` -> { timer }
const quantityDebounceMap = new Map();
const joinedRooms = new Set();

const socketMiddleware = (socket) => (store) => (next) => (action) => {
  // 1. Synchronously update Redux state first (zero latency for the UI)
  const result = next(action);

  if (action.isSocket) {
    const { branchId, restaurantId, id } = store.getState().user;
    const channels = [id, branchId];

    if (Boolean(id)) {
      const ensureRoomsJoined = () => {
        channels.forEach((channel) => {
          if (channel && !joinedRooms.has(channel)) {
            socket.emit("JOIN_ROOM", channel);
            joinedRooms.add(channel);
          }
        });
      };

      if (socket.connected === false) {
        socket[action.type === "SET_PRINT_DATA_FOR_ADMIN" ? "once" : "on"]("connect", () => {
          joinedRooms.clear();
          ensureRoomsJoined();
          socket.emit("GET_ORDERS", {
            branchId,
            restaurantId,
            userId: id,
          });
          socket.emit(action.type, {
            branchId,
            restaurantId,
            userId: id,
            ...action.payload,
          });
        });
      } else {
        ensureRoomsJoined();

        // 2. Debounce quantity changes (300ms) to collapse rapid +/- taps
        if (action.type === orderTypes.CHANGE_ITEM_QUANTITY) {
          const { refId, itemId } = action.payload || {};
          const key = `${refId}_${itemId}`;

          if (quantityDebounceMap.has(key)) {
            clearTimeout(quantityDebounceMap.get(key).timer);
          }

          const currentOrder = store.getState().order?.activeOrders?.find(
            (o) => o.refId === refId
          );
          const currentItem = currentOrder?.orderItems?.find(
            (it) => (it.itemId || it._id || it.id)?.toString() === itemId?.toString()
          );
          const targetQty = currentItem?.quantity;
          const currentRev = currentOrder?._rev;

          const timer = setTimeout(() => {
            quantityDebounceMap.delete(key);
            if (socket.connected) {
              socket.emit(action.type, {
                branchId,
                restaurantId,
                userId: id,
                ...action.payload,
                targetQuantity: targetQty,
                clientRev: currentRev,
                clientTimestamp: Date.now(),
              });
            }
          }, 300);

          quantityDebounceMap.set(key, { timer });
        } else {
          // If item is removed, cancel any pending quantity timer for that item
          if (action.type === orderTypes.REMOVE_ITEM) {
            const { refId, itemId } = action.payload || {};
            const key = `${refId}_${itemId}`;
            if (quantityDebounceMap.has(key)) {
              clearTimeout(quantityDebounceMap.get(key).timer);
              quantityDebounceMap.delete(key);
            }
          }

          const currentOrder = store.getState().order?.activeOrders?.find(
            (o) => o.refId === action.payload?.refId
          );

          socket.emit(action.type, {
            branchId,
            restaurantId,
            userId: id,
            clientRev: currentOrder?._rev,
            clientTimestamp: Date.now(),
            ...action.payload,
          });
        }
      }
    }
  }

  return result;
};

export default socketMiddleware;
